/**
 * Created by Ning Jiang on 2024-08-27.
 */

import {ElGordosRevengeGameAssets} from "../ElGordosRevengeGameAssets";
import {ElGordosRevenge} from "../ElGordosRevenge";
import {ElGordosRevengeLayers, Layers} from "./ElGordosRevengeLayers";
import {TimelineLite, TweenLite} from "gsap";
import {BitmapText} from "pixi.js";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {IMeterData} from "../server/data/IElGordosRevengeData";
import {MathHelper} from "../../core/utils/MathHelper";
import {ElGordosRevengeGameConfig} from "../ElGordosRevengeGameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {CollectBonusController} from "../winpresentation/presentations/CollectBonusController";
import {ElGordosRevengeSound} from "../sound/ElGordosRevengeSound";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

class MeterAnchor extends PIXI.Container {

    private _offTint = 0x999999;
    private _multiOffBrightness = 0.4;
    private _multiCollectedBrightness = 0.7;
    private _multiUsedBrightness = 0.3;
    private _ropeAnchors = [[0.5, 0.67], [0.5, 0.66], [0.5, 0.66], [0.5, 0.66], [0.5, 0.67]];

    public readonly levelIndex:number;
    public currentMulti:number;
    public fsLeft:number;
    public enabled:boolean;
    public isCollected:boolean;
    private _isCurrentLevel:boolean;

    public steps:MeterStep[] = [];

    private _on:PIXI.Sprite;
    private _off:PIXI.Sprite;
    private _xNudgeLogo:PIXI.Sprite;
    private _rope:PIXI.Sprite;
    private _multiText:PIXI.BitmapText;
    private _fsContainer:PIXI.Container;
    private _plus:PIXI.Sprite;
    private _fsNumber:PIXI.BitmapText;
    private _fsSpinText:PIXI.Sprite;
    private _anchorFire:PIXI.spine.Spine | null;
    private _anchorFireContainer:PIXI.Container;
    private _fireLine:PIXI.spine.Spine | null;
    private _fireLineContainer:PIXI.Container;
    private _fireLineTl:TimelineLite | null;

    constructor(levelIndex:number) {
        super();

        this.levelIndex = levelIndex;

        this._fireLineContainer = new PIXI.Container();
        this._fireLineContainer.position.set(0, -3);
        this.addChild(this._fireLineContainer);

        this._xNudgeLogo = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("meter/Xnudge_board_gray")[0]);
        this._xNudgeLogo.anchor.set(0.5, 0);
        this._xNudgeLogo.scale.set(0.6, 0.6);
        this._xNudgeLogo.y = 24;
        this.addChild(this._xNudgeLogo);

        this._off = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures(`meter/anchorOff`)[0]);
        this._off.anchor.set(0.5, 0.66);
        this._off.scale.set(0.9);
        this.addChild(this._off);

        this._on = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures(`meter/anchorOn`)[0]);
        this._on.anchor.set(0.5, 0.66);
        this._on.scale.set(0.9);
        this.addChild(this._on);
        this._on.visible = false;

        this._anchorFireContainer = new PIXI.Container();
        this.addChild(this._anchorFireContainer);
        this._anchorFireContainer.visible = false;

        this._fsContainer = new PIXI.Container();
        this._fsContainer.y = -44;
        this.addChild(this._fsContainer);

        this._plus = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("freespin/+")[0]);
        this._plus.anchor.set(0, 0.5);
        this._plus.scale.set(0.25);
        this._plus.tint = this._offTint;
        this._fsNumber = new PIXI.BitmapText("5", {
            fontName : ElGordosRevengeGameAssets.BITMAP_FONT_FREESPIN_NUMBER,
            fontSize : 5,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        (<PIXI.Point>this._fsNumber.anchor).set(0, 2.2);
        this._fsNumber.tint = this._offTint;
        this._fsSpinText = new PIXI.Sprite();
        this._fsSpinText.anchor.set(1, 0.5);
        this._fsSpinText.scale.set(0.44, 0.44)
        this._fsSpinText.tint = this._offTint;

        this._fsContainer.addChild(this._plus, this._fsSpinText, this._fsNumber);
        // this.resizeFs();
        // this._fsContainer.visible = false;

        this._multiText = new PIXI.BitmapText("x1", {
            fontName : ElGordosRevengeGameAssets.BITMAP_FONT_NUDGE_MULTIPLIER,
            fontSize : 15,
            tint : ElGordosRevengeGameConfig.MULTIPLIER_TEXT_TINT
        });
        (<PIXI.Point>this._multiText.anchor).set(0.5, 1.38);
        this._multiText.letterSpacing = -12;
        this._multiText.y = -2;
        this._multiText.scale.y = 0.7;
        this.addChild(this._multiText);
        TweenLite.to(this._multiText, 0.2, {pixi : {brightness : this._multiOffBrightness}});


        this._rope = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures(`meter/rope`)[levelIndex]);
        this._rope.anchor.set(this._ropeAnchors[levelIndex][0], this._ropeAnchors[levelIndex][1]);
        this._rope.scale.set(0.8);
        this.addChild(this._rope);
        TweenLite.to(this._rope, 0.2, {pixi : {brightness : 1.5}});
    }

    private resizeFs():void {
        this._fsSpinText.texture = ElGordosRevenge.assetLoader.getTextures(`freespin/+1FS${this.fsLeft === 1 ? "" : "_S"}`)[0];
        this._fsNumber.scale.set(1);
        this._fsNumber.updateTransform();
        if(this._fsNumber.textWidth > 30) {
            this._fsNumber.scale.x = MathHelper.roundToDecimals(30 / this._fsNumber.textWidth, 2);
        }

        let plusWidth = this._plus.visible ? this._plus.width : 0;

        const totalWidth = plusWidth + this._fsNumber.textWidth * this._fsNumber.scale.x + this._fsSpinText.width + 2;
        this._plus.x = -totalWidth * 0.5;
        this._fsNumber.x = this._plus.x + plusWidth;
        this._fsSpinText.x = totalWidth * 0.5;
    }

    public collected(flag:boolean, init:boolean, timeline?:TimelineLite):void {
        if(this.isCollected === flag) {
            return;
        }
        this.isCollected = flag;

        if(init) {
            this._rope.visible = !flag;
            TweenLite.to(this._multiText, 0.2, {pixi : {brightness : this._multiOffBrightness}});
        } else {
            // only care about the animation in one way.
            if(flag && this.enabled) {
                const collectFire = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("meterFire"));
                collectFire.autoUpdate = true;
                collectFire.scale.set(0.7);
                this._anchorFireContainer.addChild(collectFire);
                const fireTl = new TimelineLite({paused : true});
                fireTl.add(() => {
                    this._anchorFireContainer.visible = true;
                    collectFire.state.setAnimation(0, "end", false);
                });
                fireTl.add(() => {
                    collectFire.state.setEmptyAnimations(0);
                    this._anchorFireContainer.removeChild(collectFire);
                    this._anchorFireContainer.visible = false;
                    collectFire.destroy();
                }, collectFire.spineData.findAnimation("end").duration);

                timeline!.add([
                    () => {fireTl.play()},
                    TweenLite.to(this._rope, 0.28, {
                        alpha : flag ? 0 : 1, onComplete : () => {
                            this._rope.visible = !flag;
                        }
                    }),
                    TweenLite.to(this._multiText, 0.2, {pixi : {brightness : this._multiOffBrightness}})
                ]);
            }
        }
    }

    public enable(flag:boolean, wasCurrent?:boolean, reset?:boolean):void {
        this.enabled = flag;
        this._fsContainer.visible = flag;
        this.steps.forEach(step => {
            step.visible = flag;
        });
        if(!flag) {
            if(this.isCollected || this._isCurrentLevel) {
                this._on.visible = true;
                this._xNudgeLogo.texture = ElGordosRevenge.assetLoader.getTextures("meter/Xnudge_board_light")[0];
            } else {
                this._on.visible = false;
                this._xNudgeLogo.texture = ElGordosRevenge.assetLoader.getTextures("meter/Xnudge_board_gray")[0];
            }
            if(reset) {
                this._on.visible = false;
                this._xNudgeLogo.texture = ElGordosRevenge.assetLoader.getTextures("meter/Xnudge_board_gray")[0];
                this._rope.visible = true;
                this._rope.alpha = 1;
                this._fsNumber.tint = this._offTint;
                this._fsSpinText.tint = this._offTint;
            }

            TweenLite.to(this._multiText, 0.2, {pixi : {brightness : this._multiUsedBrightness}});
            this._isCurrentLevel = false;
            this.isCollected = false;
            const anchorFireTl = new TimelineLite();
            if(this._anchorFire) {
                if(wasCurrent) {
                    anchorFireTl.add(() => {
                        this._anchorFire!.state.setAnimation(0, "end", false);
                    });
                    anchorFireTl.add(() => {}, this._anchorFire.spineData.findAnimation("end").duration);
                }
                anchorFireTl.add(() => {
                    this._anchorFire!.state.setEmptyAnimations(0);
                    this._anchorFireContainer.removeChild(this._anchorFire!);
                    this._anchorFire!.destroy();
                    this._anchorFire = null;
                });
            }
            anchorFireTl.add(() => {
                this._anchorFireContainer.visible = false;
            });

            const fireLineTl = new TimelineLite();
            if(this._fireLine) {
                if(wasCurrent) {
                    fireLineTl.add(() => {
                        this._fireLine!.state.setAnimation(0, "step_end", false);
                    });
                    fireLineTl.add(() => {}, this._fireLine.spineData.findAnimation("step_end").duration);
                }
                fireLineTl.add(() => {
                    this._fireLine!.state.setEmptyAnimations(0);
                    this._fireLineContainer.removeChild(this._fireLine!);
                    this._fireLine!.destroy();
                    this._fireLine = null;
                });
            }
            fireLineTl.add(() => {
                this._fireLineContainer.visible = false;
            });
        }
    }

    // TODO: scale too long text
    public setMultiplier(newValue:number, animate:boolean):void {
        if(newValue === this.currentMulti) {
            return;
        }
        this.currentMulti = newValue;
        this._multiText.text = `x${this.currentMulti}`;
        this._multiText.scale.y = 0.7;
        if(animate) {
            const targetScale = this._multiText.scale.x;
            TweenLite.fromTo(this._multiText.scale, 0.2,
                {x : targetScale * 1.3, y : targetScale * 0.7 * 1.3},
                {x : targetScale, y : targetScale * 0.7});
            const targetBrightness = this._isCurrentLevel ? 1 : this._multiOffBrightness;
            TweenLite.fromTo(this._multiText, 0.4, {pixi : {brightness : 1.2}}, {pixi : {brightness : targetBrightness}});
        }
    }

    public setFreeSpins(initValue:number, leftValue:number, animate:boolean):void {
        this.fsLeft = this.isCollected ? leftValue : initValue;
        this._plus.visible = !this._isCurrentLevel;
        this._fsNumber.text = `${this.fsLeft}`;
        this.resizeFs();
        if(animate) {
            TweenLite.fromTo(this._fsContainer.scale, 0.1, {x : 1.3, y : 1.3}, {x : 1, y : 1});
        }
    }

    public setCurrentLevel(flag:boolean, timeline?:TimelineLite):void {
        if(this._isCurrentLevel === flag) {
            return;
        }
        this._isCurrentLevel = flag;
        const targetScale = flag ? 1.2 : 1;
        this._multiText.scale.set(targetScale, targetScale * 0.7);
        TweenLite.to(this._multiText, 0.2, {pixi : {brightness : flag ? 1 : this._multiOffBrightness}});
        this._fsNumber.scale.set(targetScale);
        this._plus.visible = !this._isCurrentLevel;
        this._fsNumber.text = `${this.fsLeft}`;
        if(this._isCurrentLevel) {
            this._fsNumber.tint = 0xffffff;
            this._fsSpinText.tint = 0xffffff;
        }
        this._on.visible = flag;
        this._xNudgeLogo.texture = ElGordosRevenge.assetLoader.getTextures(flag ? "meter/Xnudge_board_light" : "meter/Xnudge_board_gray")[0];
        const tl = new TimelineLite();
        if(flag) {
            if(!this._anchorFire) {
                this._anchorFire = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("meterFire"));
                this._anchorFire.autoUpdate = true;
                this._anchorFire.scale.set(0.7);
                this._anchorFireContainer.addChild(this._anchorFire);
            }
            tl.add(() => {
                this._anchorFireContainer.visible = true;
                this._anchorFire!.state.setAnimation(0, "start", false);
            });
            tl.add(() => {
                if(this._isCurrentLevel) {
                    this._anchorFire!.state.setAnimation(0, "loop", true);
                }
            }, this._anchorFire.spineData.findAnimation("start").duration);
        } else {
            if(this._anchorFire) {
                tl.add(() => {
                    this._anchorFire!.state.setAnimation(0, "end", false);
                });
                tl.add(() => {
                    this._anchorFire!.state.setEmptyAnimations(0);
                    this._anchorFireContainer.visible = false;
                }, this._anchorFire.spineData.findAnimation("end").duration);
            }
        }
        if(timeline) {
            timeline.add(tl);
        }
        this.resizeFs();
    }

    public startSpin():void {
        this.fsLeft--;
        this._plus.visible = false;
        this._fsNumber.text = `${this.fsLeft}`;
        this.resizeFs();
    }

    public playStepFireLine(stepIndex:number):void {
        if(!this._fireLine) {
            this._fireLine = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("meterFire"));
            this._fireLine.autoUpdate = true;
            this._fireLineContainer.addChild(this._fireLine);
        }
        if(this._fireLineTl && this._fireLineTl.isActive()) {
            this._fireLineTl.pause();
        }
        const stepName = `step${stepIndex + 1}`;
        this._fireLineContainer.visible = true;
        this._fireLine.state.setAnimation(0, `${stepName}_start`, false);
        const tl = new TimelineLite();
        tl.add(() => {
            this._fireLine!.state.setAnimation(0, `${stepName}_loop`, true);
        }, this._fireLine.spineData.findAnimation(`${stepName}_start`).duration);
        this._fireLineTl = tl;
    }

    public playFireLineBoost():void {
        if(!this._fireLine) {
            this._fireLine = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("meterFire"));
            this._fireLine.autoUpdate = true;
            this._fireLineContainer.addChild(this._fireLine);
        }
        if(this._fireLineTl && this._fireLineTl.isActive()) {
            this._fireLineTl.pause();
        }
        this._fireLineContainer.visible = true;
        this._fireLine.state.setAnimation(0, `all_step_boost`, false);
        const tl = new TimelineLite();
        tl.add(() => {
            this._fireLine!.state.setAnimation(0, `step4_loop`, true);
        }, this._fireLine.spineData.findAnimation(`all_step_boost`).duration);
        this._fireLineTl = tl;
    }
}

class MeterStep extends PIXI.Container {

    private _off:PIXI.Sprite;
    private _on:PIXI.Sprite;
    public readonly stepIndex:number;
    private readonly anchor:MeterAnchor;
    private readonly indexInLevel:number;

    constructor(index:number, anchor:MeterAnchor, indexInLevel:number) {
        super();
        this.stepIndex = index;
        this.anchor = anchor;
        this.indexInLevel = indexInLevel;

        this._off = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures(`meter/stepOff_`)[MathHelper.randomNumberInRange(0, 3)]);
        this._off.anchor.set(0.5);
        this._off.tint = 0x666666;
        this.addChild(this._off);

        this._on = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures(`meter/stepOn_`)[MathHelper.randomNumberInRange(0, 3)]);
        this._on.anchor.set(0.5, 0.4);
        // this._on.scale.set(0.8);
        this.addChild(this._on);
        this._on.visible = false;
    }

    public collected(flag:boolean, animate:boolean, playFireLine:boolean, timeline?:TimelineLite):void {
        if(this._on.visible === flag) {
            return;
        }

        if(playFireLine && flag && !this._on.visible && this.anchor.enabled) {
            if(timeline) {
                timeline.add(() => {this.playFireLineToMe();});
            } else {
                this.playFireLineToMe();
            }
        }

        if(animate) {
            // only care about the animation in one way.
            timeline!.add([
                () => {
                    if(flag && !this._on.visible) {
                        const fire = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("meterSkullFire"));
                        fire.autoUpdate = true;
                        fire.scale.set(0.7);
                        fire.y = -10;
                        const aniName = `skull_fire_${MathHelper.randomNumberInRange(1, 3)}`;
                        this.addChild(fire);
                        fire.state.setAnimation(0, aniName, false);
                        ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.METER_STEP_FILL[this.indexInLevel]});
                        this._on.visible = true;
                        const tl = new TimelineLite()
                        tl.add(TweenLite.fromTo(this._on, 0.3, {alpha : 0}, {alpha : 1}));
                        tl.add(() => {
                            if(fire.parent && fire.state) {
                                this.removeChild(fire);
                                fire.destroy();
                            }
                        }, fire.spineData.findAnimation(aniName).duration);
                    }
                }
            ]);
        } else {
            this._on.visible = flag;
        }
    }

    private playFireLineToMe():void {
        this.anchor.playStepFireLine(this.indexInLevel);
    }
}

export class FSMeter extends PIXI.Container {

    private _stepSpacing:number = 2;
    private _stepWidth:number = 20;
    private _anchorWidth:number = 70;
    private _multiplierCollectLevelPositions:[number, number][] = [
        [450, 630], [570, 630], [654, 630], [710, 630], [710, 630]
    ]; // 40

    private _initialized:boolean;
    private _actualWidth:number = 0;
    private _currentCollectedNr:number = 0;

    private _bgGlowContainer:PIXI.Container;
    private _bgSpine:PIXI.spine.Spine | null;
    private _innerContainer:PIXI.Container;
    private _anchorsContainer:PIXI.Container;
    private _stepsContainer:PIXI.Container;

    private _meterAnchors:MeterAnchor[] = [];
    private _meterSteps:MeterStep[] = [];
    private _meterItems:(MeterAnchor | MeterStep)[] = [];
    private _currentAnchor:MeterAnchor | null;
    private _bgGlowTl:TimelineLite | null;

    constructor() {
        super();

        this._bgGlowContainer = new PIXI.Container();
        this._bgGlowContainer.scale.x = 1.1;
        this.addChild(this._bgGlowContainer);

        const bg = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("meter/bar")[0]);
        bg.anchor.set(0.5, 0.5);
        this.addChild(bg);

        this._innerContainer = new PIXI.Container();
        this.addChild(this._innerContainer);

        this._anchorsContainer = new PIXI.Container();
        this._stepsContainer = new PIXI.Container();
        this._innerContainer.addChild(this._stepsContainer, this._anchorsContainer);
        this.position.set(360, 650);
        ElGordosRevengeLayers.getLayer(Layers.FS_METER)?.addChild(this);

        this.visible = false;
    }

    public isFull():boolean {
        if(!ElGordosRevenge.model.data.mode.includes("FREESPIN")) {
            return false;
        }
        return this._meterSteps.length > 0 && this._currentCollectedNr >= this._meterSteps.length;
    }

    public getCurrentLevelMultiplier():number {
        if(this._currentAnchor) {
            return this._currentAnchor.currentMulti;
        }
        return 1;
    }

    public getCurrentLevelFSLeft():number {
        if(this._currentAnchor) {
            return this._currentAnchor.fsLeft;
        }
        return -1;
    }

    public getNextStepGlobalPosition():PIXI.Point {
        if(this._currentCollectedNr == this._meterSteps.length) {
            debugger;
            throw new Error(`FSMeter.getNextStepGlobalPosition(): current step is already last step!`);
        }
        const nextStep = this._meterSteps[this._currentCollectedNr];
        return new PIXI.Point(nextStep.x + this._innerContainer.x + this.x, nextStep.y + this._innerContainer.y + this.y);
    }

    public getAnchorGlobalPosition(index:number):PIXI.Point {
        const anchor = this._meterAnchors[index];
        return new PIXI.Point(anchor.x + this._innerContainer.x + this.x, anchor.y + this._innerContainer.y + this.y);
    }

    // 0-small, 1-big win.
    private playBgGlow(index:number):void {
        if(!this._bgSpine) {
            this._bgSpine = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("meterGlow"));
            this._bgSpine.autoUpdate = true;
            this._bgGlowContainer.addChild(this._bgSpine);
        }
        if(this._bgGlowTl && this._bgGlowTl.isActive()) {
            this._bgGlowTl.pause();
            this._bgGlowTl.kill();
        }
        const aniName = index === 0 ? "win_small" : "win_big";
        this._bgSpine.state.setAnimation(0, aniName, false);
        const tl = new TimelineLite();
        tl.add(() => {
            if(this._bgSpine) {
                this._bgSpine.state.setAnimation(0, "idle", true);
            }
            this._bgGlowTl = null;
        }, this._bgSpine.spineData.findAnimation(aniName).duration);
        this._bgGlowTl = tl;
    }

    // animation to show?
    public show(extraS1:boolean):TimelineLite {
        const tl = new TimelineLite();
        const data = ElGordosRevenge.model.data.fsMeterData
        if(!this._initialized) {
            let stepIndex = 1;
            data.meterMultipliersAfter.forEach((multiplier, levelIndex) => {
                const lastAnchor = (levelIndex + 1) === data.meterMultipliersAfter.length;
                const anchor = new MeterAnchor(levelIndex);
                anchor.x = this._actualWidth + this._anchorWidth * 0.5;
                this._anchorsContainer.addChild(anchor);
                this._meterAnchors.push(anchor);
                this._meterItems.push(anchor);
                this._actualWidth += this._anchorWidth;

                if(!lastAnchor) {
                    this._actualWidth += this._stepSpacing;
                    const nrSteps = data.bnNeededToUpgrade[levelIndex];
                    for(let i = 0; i < nrSteps; i++) {
                        const step = new MeterStep(stepIndex++, anchor, i);
                        step.x = this._actualWidth + this._stepWidth * 0.5;
                        this._stepsContainer.addChild(step);
                        this._meterSteps.push(step);
                        this._meterItems.push(step);
                        anchor.steps.push(step);
                        this._actualWidth += this._stepWidth + this._stepSpacing;
                    }
                }
            });
            this._innerContainer.x = -this._actualWidth * 0.5;
            this._initialized = true;
        }

        if(extraS1) {
            this._currentCollectedNr = 0;
        } else {
            this._currentCollectedNr = data.numberOfBNcollectedAfter;
        }
        let currentStepIndex = -1;
        this._meterItems.forEach((item, index) => {
            if(item instanceof MeterStep) {
                item.collected(item.stepIndex <= this._currentCollectedNr, false, true);
                currentStepIndex = item.stepIndex;
            } else if(item instanceof MeterAnchor) {
                item.collected(currentStepIndex <= this._currentCollectedNr, true);
                item.setMultiplier(data.meterMultipliersAfter[item.levelIndex], false);
                item.setFreeSpins(data.freespinAwardedPerLevel[item.levelIndex], data.freeSpinLeftArray[item.levelIndex], false);
                item.setCurrentLevel(item.levelIndex === data.fsLevel, tl);
                if(item.levelIndex === data.fsLevel) {
                    this._currentAnchor = item;
                }
                item.enable(item.levelIndex >= data.fsLevel);
                if(index === 0 && extraS1) {
                    const s1Tl = new TimelineLite();
                    const s1 = ElGordosRevenge.scatters.scatters[3];
                    const symbolGlobalPosition = s1.getGlobalCenterPosition();
                    s1Tl.add(s1.playWin());
                    // TODO: change S1 to used BN state.
                    s1Tl.add(CollectBonusController.playSwoosh(symbolGlobalPosition, ElGordosRevenge.fsMeter.getNextStepGlobalPosition()));
                    s1Tl.add(() => (this.addSteps(2, true)));
                    s1Tl.add(() => {}, `+=1`);
                    tl.add(s1Tl, `-=0.5`);
                }
            }
        });

        this.visible = true;
        this.playBgGlow(0);
        return tl;
    }

    public hide():void {
        this.visible = false;
        if(this._bgSpine) {
            this._bgSpine.state.setEmptyAnimations(0);
            this._bgGlowContainer.removeChild(this._bgSpine);
            this._bgSpine.destroy();
            this._bgSpine = null;
        }
        this._currentAnchor = null;
        this._currentCollectedNr = 0;
        this._meterAnchors.forEach(anchor => {
            anchor.enable(false, false, true);
        });
        // TODO: stop if any idle animation.
    }

    public updateBeforeSpin(meterData:IMeterData):void {
        if(meterData.freeSpinLeftArray[meterData.fsLevel] == 0) {
            this._currentAnchor!.enable(false, true);
            const newAnchor = this._meterAnchors[meterData.fsLevel + 1];
            newAnchor.setCurrentLevel(true);
            this._currentAnchor = newAnchor;
            this.playBgGlow(0);
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.METER_LVL_UP});
        }
        this._currentAnchor!.startSpin();
        SlotGame.keypadPlugin.setZeroBetSpinCounter(this._currentAnchor!.fsLeft);
    }

    public addSteps(nr:number, playFireLine:boolean):TimelineLite {
        this._currentCollectedNr += nr;
        const tl = new TimelineLite();
        let currentStepIndex = -1;
        if(nr > 1) {
            tl.add(() => {
                this.playBgGlow(1);
            });
        } else {
            tl.add(() => {
                this.playBgGlow(2);
            });
        }
        this._meterItems.forEach((item) => {
            if(item instanceof MeterStep) {
                item.collected(item.stepIndex <= this._currentCollectedNr, true, playFireLine, tl);
                currentStepIndex = item.stepIndex;
            } else if(item instanceof MeterAnchor) {
                item.collected(currentStepIndex <= this._currentCollectedNr, false, tl);
            }
        });

        return tl;
    }

    public addBNMultipliers(multiText:BitmapText):TimelineLite {
        if(this._currentAnchor!.levelIndex === this._meterAnchors.length - 1) {
            //this._currentAnchor!.setMultiplier(this._currentAnchor!.currentMulti + 1);
            debugger;
            throw new Error(`FSMeter.addMultipliers() There shall be no BN in the last fs level!`);
        }
        const toPosition = this.getAnchorGlobalPosition(this._currentAnchor!.levelIndex + 1);
        const tl = new TimelineLite();
        tl.add([
            TweenLite.to(multiText, 0.8, {x : toPosition.x, ease : "power2.out"}),
            TweenLite.to(multiText, 0.8, {y : toPosition.y, ease : "back.in(1.7)"})
        ]);
        tl.add(() => {
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.METER_MULTIPLIERS_UP});
            this.playBgGlow(0);

            let anchor = this._meterAnchors[this._currentAnchor!.levelIndex + 1];
            anchor.setMultiplier(anchor.currentMulti + 1, true);
        });
        const counter = 4 - this._currentAnchor!.levelIndex - 1;
        if(counter > 0) {
            const endPosition = this.getAnchorGlobalPosition(4);
            const duration = 0.1 * counter;
            let time = 0.1;
            const multiTl = new TimelineLite();
            for(let i = this._currentAnchor!.levelIndex + 2; i < 5; i++) {
                const anchor = this._meterAnchors[i];
                multiTl.add(() => {
                    anchor.setMultiplier(anchor.currentMulti + 1, true);
                }, time);
                time += 0.1;
            }
            const swoosh = new TimelineSprite(ElGordosRevenge.assetLoader.getTextures("animJpeg/meterSwoosh/meterSwoosh_"), 20 / duration);
            swoosh.blendMode = PIXI.BLEND_MODES.ADD;
            swoosh.alpha = 0.7;
            swoosh.scale.y = 0.4;
            swoosh.width = endPosition.x - toPosition.x;
            swoosh.anchor.set(0, 0.5);
            swoosh.position.set(toPosition.x, toPosition.y);
            tl.add([
                () => {
                    ElGordosRevengeLayers.getLayer(Layers.METER_EFFECTS)!.addChild(swoosh);
                    ElGordosRevengeLayers.getLayer(Layers.METER_EFFECTS)!.addChild(multiText);
                },
                swoosh.getAnimationAutoShowHide(),
                multiTl,
                TweenLite.to(multiText, duration, {x : endPosition.x, ease : "power2.out"})
            ]);
            tl.add(() => {
                swoosh.parent.removeChild(swoosh);
                swoosh.destroy();
            });
        }
        tl.add(() => {
            multiText.parent.removeChild(multiText);
            multiText.destroy();
        });

        return tl;
    }

    public addBNFSLeft(fsTexts:PIXI.Container[]):TimelineLite {
        const data = ElGordosRevenge.model.data.fsMeterData;
        const to = this.getAnchorGlobalPosition(this._currentAnchor!.levelIndex);
        const tl = new TimelineLite();
        let delay = 0;
        fsTexts.forEach(text => {
            tl.add([
                TweenLite.to(text, 0.8, {x : to.x, ease : "power2.out"}),
                TweenLite.to(text, 0.8, {
                    y : to.y - 44, ease : "back.in(1.4)",
                    onComplete : () => {
                        text.parent.removeChild(text);
                        text.destroy();
                    }
                })
            ], delay);
            delay += 0.08;
        });
        const fsLeft = this._currentAnchor!.fsLeft + fsTexts.length;
        tl.add(() => {
            this.playBgGlow(0);
            this._currentAnchor?.setFreeSpins(data.freespinAwardedPerLevel[this._currentAnchor.levelIndex], fsLeft, true)
            SlotGame.keypadPlugin.setZeroBetSpinCounter(this._currentAnchor!.fsLeft);
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.METER_PLUS_SPINS});
        });

        return tl;
    }

    public updateFsLevel():TimelineLite {
        const steps = ElGordosRevenge.model.parsedGameData.fsMeterData.numberOfBNcollectedAfter - this._currentCollectedNr;
        const tl = this.addSteps(steps, false);
        let newAnchorIndex = 0;
        this._meterAnchors.forEach((anchor, index) => {
            if(anchor.isCollected) {
                newAnchorIndex = index;
            }
        });
        tl.add([
            this._meterAnchors[Math.max(newAnchorIndex - 1, 0)].playFireLineBoost(),
            () => {this.playBgGlow(1)}
        ]);
        return tl
    }

    public addCylinderMultipliers(multipliers:number[]):TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            this._meterAnchors.forEach((anchor, index) => {
                anchor.setMultiplier(anchor.currentMulti + multipliers[index], true);
            });
            this.playBgGlow(0);
        });
        return tl;
    }

    public verifyMeterValues():void {
        if(!NolimitConfig.isDevMode) {
            return;
        }
        if(!ElGordosRevenge.model.parsedGameData.mode.includes(GameMode.FREESPIN)) {
            return;
        }

        const meterData = ElGordosRevenge.model.parsedGameData.fsMeterData;
        if(meterData.fsLevel != this._currentAnchor!.levelIndex) {
            debugger;
            throw new Error("Displaying FS Meter current level doesn't match server data.");
        }
        this._meterAnchors.forEach((anchor, level) => {
            if(anchor.levelIndex < meterData.fsLevel) {
                return;
            }
            if(anchor.currentMulti != meterData.meterMultipliersAfter[level]) {
                debugger;
                throw new Error(`Displaying FS Meter level ${level} multiplier doesn't match server data.`);
            }
        });

        if(this._currentCollectedNr != meterData.numberOfBNcollectedAfter) {
            debugger;
            throw new Error(`Displaying collected BN number doesn't match server data.`);
        }
        // TODO: verify steps?
    }
}